
import TranResourcesApi from './src/Tranresources'
import LinesApi from './src/Lines'
import StationsApi from './src/Stations'
import LineStationRelationApi from './src/LineStationRelation'


let apis = {
   TranResourcesApi,
   LinesApi,
   StationsApi,
   LineStationRelationApi
};

export default apis;
